
function checkButton() { 	    
        
           
let getFishValue = document.querySelector(   
             'input[name="fish-amount"]:checked'); 
	
	if (getFishValue === null) {
	 document.getElementById("disp").innerHTML = "Please Select Frequency"	

}
	

let getFamValue = document.querySelector(   
             'input[name="fam-amount"]:checked');  
	
		if (getFamValue === null) {
	 document.getElementById("disp").innerHTML = "Please Select Household Amount"	

}
		
if ( getFamValue === null && getFishValue === null ) {
	 document.getElementById("disp").innerHTML = "Select Amount"	
}	

let sum = +getFishValue.value + +getFamValue.value;
	

let finala;
let finalb
switch (sum) {
  case 6:
    finala = '10 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115860777">3 lb Bi-Monthly Share</a>';
    break;
  case 7:
	finala = '20 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115860777">3 lb Bi-Monthly Share</a>';
    break;
  case 8:
	finala = '20 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115860777">3 lb Bi-Monthly Share</a>';
    break;
  case 10:
	finala = '10 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115860777">3 lb Bi-Monthly Share</a>';
    break;
  case 11:
	finala = '20 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115762473">3 lb Monthly Share</a>';
    break;
  case 12:
	finala = '40 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115762473">3 lb Monthly Share</a>';
    break;
  case  14:
	finala = '20 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115762473">3 lb Monthly Share</a>';
   break;
  case  15:
	finala = '40 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115762473">3 lb Monthly Share</a>';
  	break;
  case  16:
	finala = '60 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115795241">6 lb Monthly Share</a>';
  	break;
  case  18:
	finala = '40 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115762473">3 lb Monthly Share</a>';
 	break;
  case  19:
	finala = '60 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115795241">6 lb Monthly Share</a>';
	break;
  case  20:
	finala = '80 lb';
	finalb = '<a href="/products/monthly-share?variant=47222115828009">9 lb Monthly Share</a>';
	break;
	default: "WTF";
}
	

	  
if( sum !== false) { 
	document.getElementById("suggestion");
	suggestion.style.display = "flex";
	
	
		 document.getElementById("equals").innerHTML = "SUGGESTED AMOUNT = ";
		/* document.getElementById("calls").innerHTML = "PLEASE CLICK ON A LINK TO PURCHASE";*/
          document.getElementById("outputOne").innerHTML = finala;
		/*  document.getElementById("outputTwo").innerHTML = finalb;
		  document.getElementById("disp").innerHTML = "OR"; */
		  document.getElementById("but").innerHTML = "RECALCULATE";
			 }  
		   
		   
	 else {   
                document.getElementById("disp").innerHTML   
                    = "Please make a selection";  
			 }   



		   
	}

